import Cookies from 'js-cookie'

const machineKey = 'machineId'

export function getMachineId() {
  return Cookies.get(machineKey) || localStorage.getItem(machineKey);
}

export function setMachineId(id) {
  localStorage.setItem(machineKey, id);
  return Cookies.set(machineKey, id);
}

export function removeMachineId() {
  return Cookies.remove(machineKey)
}




// WEBPACK FOOTER //
// ./src/utils/global.js